import React, { useState } from 'react';
import { Check, X, Star, Shield, MessageCircle, Users, Dumbbell, DollarSign } from 'lucide-react';
import { Countdown } from '../components/Countdown';
import { FAQItem } from '../components/FAQItem';
import { StickyBar } from '../components/StickyBar';
import { ImageHint } from '../components/ImageHint';
import { TrustBadges } from '../components/TrustBadges';
import { MobileStickyTopBar } from '../components/MobileStickyTopBar';
export function KitMasajista() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <div className="min-h-screen bg-cream font-dmsans text-text selection:bg-gold/30" data-id="element-95">
      <MobileStickyTopBar data-id="element-96" />

      {/* 1. HERO SECTION */}
      <section className="relative min-h-screen flex flex-col items-center justify-center text-center px-6 pt-24 md:pt-20 pb-14 overflow-hidden" style={{
      backgroundImage: 'linear-gradient(to bottom right, rgba(16, 12, 4, 0.78), rgba(29, 20, 8, 0.78)), var(--mp-image, url(https://cdn.magicpatterns.com/uploads/os5dvJYx9mEN7tccxjmB4L/img1_landing.jpg))',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }} data-mp-image="hero-background" data-id="element-97">
        {/* Background glow */}
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_65%_55%_at_50%_38%,rgba(200,155,60,0.13)_0%,transparent_68%)] pointer-events-none" data-id="element-98" />

        <div className="relative z-10 max-w-4xl mx-auto flex flex-col items-center" data-id="element-99">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/40 text-gold-light text-[11px] font-bold tracking-[2px] uppercase px-5 py-2 rounded-full mb-6" data-id="element-100">
            <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse-slow" data-id="element-101"></span>
            Kit Profesional del Masajista – Método M.A.S.A.J.E™ 360
          </div>

          <h1 className="font-playfair text-[clamp(32px,5.5vw,62px)] font-black text-white leading-[1.08] max-w-[860px] mb-2.5" data-id="element-102">
            <span className="block text-white/90 text-[0.82em] font-bold tracking-tight mb-1.5" data-id="element-103">
              En menos de 7 días vas a dejar de improvisar
            </span>
            <span className="block text-gold" data-id="element-104">
              y empezar a trabajar como una masajista profesional que cobra con
              seguridad.
            </span>
            <span className="block text-white text-[0.88em] mt-1.5" data-id="element-105">
              Aunque hoy no sepas por dónde empezar.
            </span>
          </h1>

          <div className="inline-block my-3.5 mb-5 bg-white/5 border border-gold/35 rounded-md px-5 py-2.5 text-[13px] text-white/70 tracking-wide max-w-2xl" data-id="element-106">
            Aplicando el{' '}
            <strong className="text-gold-light font-bold" data-id="element-107">
              Método M.A.S.A.J.E.™
            </strong>{' '}
            — el sistema que te da orden, confianza e ingresos desde el primer
            día, en un solo kit descargable listo para usar hoy mismo.
          </div>

          <ul className="flex flex-col gap-2.5 my-5 mb-7 text-left max-w-[560px]" data-id="element-108">
            <li className="flex items-start gap-2.5 text-[15px] text-white/80 leading-relaxed" data-id="element-109">
              <Check className="text-accent shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-110" />
              <span data-id="element-111">
                <strong className="text-white font-semibold" data-id="element-112">
                  Sabés exactamente qué hacer
                </strong>{' '}
                en cada sesión, de principio a fin, sin dudar
              </span>
            </li>
            <li className="flex items-start gap-2.5 text-[15px] text-white/80 leading-relaxed" data-id="element-113">
              <Check className="text-accent shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-114" />
              <span data-id="element-115">
                <strong className="text-white font-semibold" data-id="element-116">
                  Dejás de dudar cuánto cobrar
                </strong>{' '}
                y empezás a fijar precios con seguridad
              </span>
            </li>
            <li className="flex items-start gap-2.5 text-[15px] text-white/80 leading-relaxed" data-id="element-117">
              <Check className="text-accent shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-118" />
              <span data-id="element-119">
                <strong className="text-white font-semibold" data-id="element-120">
                  Generás una experiencia profesional
                </strong>{' '}
                que hace que tus clientes vuelvan solos
              </span>
            </li>
            <li className="flex items-start gap-2.5 text-[15px] text-white/80 leading-relaxed" data-id="element-121">
              <Check className="text-accent shrink-0 mt-0.5" size={18} strokeWidth={3} data-id="element-122" />
              <span data-id="element-123">
                <strong className="text-white font-semibold" data-id="element-124">
                  Organizás tu agenda
                </strong>{' '}
                para ganar más sin trabajar todo el día
              </span>
            </li>
          </ul>

          <div className="flex items-center justify-center gap-4 flex-wrap my-5 mb-7" data-id="element-125">
            <span className="text-lg text-white/30 line-through font-medium" data-id="element-126">
              $44.997
            </span>
            <span className="font-playfair text-[52px] font-black text-gold-light leading-none" data-id="element-127">
              $18.999
            </span>
            <span className="bg-[#E8A830] text-dark text-xs font-extrabold px-3 py-1.5 rounded tracking-wide" data-id="element-128">
              -57% OFF
            </span>
          </div>

          <div className="flex flex-col items-center gap-3 mb-4" data-id="element-129">
            <a href="#precio" className="btn-gold text-[19px] px-12 py-5 rounded-lg" data-id="element-130">
              👉 QUIERO MI KIT PROFESIONAL AHORA
            </a>
            <span className="text-xs text-white/40 tracking-wide" data-id="element-131">
              Acceso inmediato · Pago único · Sin experiencia previa
            </span>
            <span className="text-xs text-white/50 tracking-wide flex items-center gap-1.5" data-id="element-132">
              <Users size={13} className="text-gold" data-id="element-133" /> Acceso a comunidad
              privada de masajistas
            </span>
          </div>

          <Countdown data-id="element-134" />

          <div className="flex flex-wrap justify-center gap-4 mt-1.5" data-id="element-135">
            <span className="flex items-center gap-1.5 text-xs text-white/40 tracking-wide" data-id="element-136">
              <Check className="text-green" size={14} strokeWidth={4} data-id="element-137" /> Pago
              100% seguro
            </span>
            <span className="flex items-center gap-1.5 text-xs text-white/40 tracking-wide" data-id="element-138">
              <Check className="text-green" size={14} strokeWidth={4} data-id="element-139" />{' '}
              Garantía 7 días sin preguntas
            </span>
            <span className="flex items-center gap-1.5 text-xs text-white/40 tracking-wide" data-id="element-140">
              <Check className="text-green" size={14} strokeWidth={4} data-id="element-141" /> +500
              masajistas ya lo usan
            </span>
            <span className="flex items-center gap-1.5 text-xs text-white/40 tracking-wide" data-id="element-142">
              <Check className="text-green" size={14} strokeWidth={4} data-id="element-143" /> Sin
              suscripciones
            </span>
          </div>

          <div className="w-[70px] h-[2px] bg-gradient-to-r from-transparent via-gold to-transparent mx-auto mt-10" data-id="element-144"></div>
        </div>
      </section>

      {/* Trust Badges - Inserted after hero */}
      <div className="bg-dark py-8" data-id="element-145">
        <TrustBadges data-id="element-146" />
      </div>

      {/* 2. SOCIAL PROOF BAR */}
      <div className="bg-dark-2 border-y border-gold/20 py-4 px-6" data-id="element-147">
        <div className="max-w-5xl mx-auto flex items-center justify-center gap-10 flex-wrap" data-id="element-148">
          <div className="flex flex-col items-center gap-0.5" data-id="element-149">
            <div className="font-playfair text-[26px] font-black text-gold-light" data-id="element-150">
              +500
            </div>
            <div className="text-xs text-white/45 tracking-wide uppercase" data-id="element-151">
              Masajistas activas
            </div>
          </div>
          <div className="w-px h-9 bg-white/10 hidden sm:block" data-id="element-152"></div>
          <div className="flex flex-col items-center gap-0.5" data-id="element-153">
            <div className="font-playfair text-[26px] font-black text-gold-light" data-id="element-154">
              ★ 4.9
            </div>
            <div className="text-xs text-white/45 tracking-wide uppercase" data-id="element-155">
              Calificación promedio
            </div>
          </div>
          <div className="w-px h-9 bg-white/10 hidden md:block" data-id="element-156"></div>
          <div className="flex flex-col items-center gap-0.5" data-id="element-157">
            <div className="font-playfair text-[26px] font-black text-gold-light" data-id="element-158">
              100%
            </div>
            <div className="text-xs text-white/45 tracking-wide uppercase" data-id="element-159">
              Digital · Acceso inmediato
            </div>
          </div>
          <div className="w-px h-9 bg-white/10 hidden lg:block" data-id="element-160"></div>
          <div className="flex flex-col items-center gap-0.5" data-id="element-161">
            <div className="font-playfair text-[26px] font-black text-gold-light" data-id="element-162">
              7 días
            </div>
            <div className="text-xs text-white/45 tracking-wide uppercase" data-id="element-163">
              Garantía sin preguntas
            </div>
          </div>
        </div>
      </div>

      {/* 3. PAIN POINTS */}
      <section className="bg-dark py-20 px-6" data-id="element-164">
        <div className="max-w-3xl mx-auto" data-id="element-165">
          <p className="section-eyebrow text-gold/75" data-id="element-166">¿Te suena familiar?</p>
          <h2 className="text-white mb-4" data-id="element-167">
            Si sos masajista, probablemente
            <br data-id="element-168" />
            te esté pasando <em className="text-gold-dark not-italic" data-id="element-169">esto…</em>
          </h2>
          <p className="text-[17px] text-white/60 leading-relaxed mb-7" data-id="element-170">
            No es falta de talento. No es falta de ganas. Es que nadie te enseñó
            un sistema claro para trabajar como profesional.
          </p>

          <ul className="flex flex-col gap-3 mb-9" data-id="element-171">
            {['Sentís que **improvisás en cada sesión** y salís sin saber si estuvo bien', '**No sabés cuánto cobrar** y terminás bajando el precio por miedo a perder el cliente', 'Tenés clientes pero **no lográs estabilidad** — un mes bien, otro mes nada', 'Te cuesta que vuelvan o que te recomienden, y **no entendés por qué**', 'Te gusta lo que hacés pero **no estás ganando lo que deberías** ganar con este trabajo'].map((text, i) => <li key={i} className="flex items-start gap-3.5 bg-white/5 border border-white/10 rounded-lg p-4 text-white/80 text-[16px] leading-relaxed" data-id="element-172">
                <div className="w-[22px] h-[22px] min-w-[22px] rounded-full bg-red/20 flex items-center justify-center mt-0.5 text-[11px] text-[#E74C3C] font-extrabold" data-id="element-173">
                  <X size={14} strokeWidth={4} data-id="element-174" />
                </div>
                <span data-id="element-175">
                  {text.split(/(\*\*.*?\*\*)/g).map((part, j) => part.startsWith('**') ? <strong key={j} className="text-white font-bold" data-id="element-176">
                        {part.slice(2, -2)}
                      </strong> : part)}
                </span>
              </li>)}
          </ul>

          <div className="bg-gradient-to-br from-dark to-dark-2 rounded-xl p-6 md:p-8 text-center mt-8" data-id="element-177">
            <p className="text-gold-light text-[19px] font-semibold font-playfair italic" data-id="element-178">
              👉 Si te pasa esto, no es tu culpa.
              <br data-id="element-179" />
              Es porque nadie te enseñó un sistema claro para trabajar como
              profesional.
            </p>
          </div>

          <div className="mt-10" data-id="element-180">
            <img src="https://cdn.magicpatterns.com/uploads/mnStM3sLPD36KYpgm8BoGE/img2_landing.jpg" alt="Masajista pensativa en su gabinete" className="w-full max-w-md mx-auto rounded-xl shadow-2xl" style={{
            objectFit: 'cover'
          }} data-mp-image="pain-points-image" data-id="element-181" />
          </div>
        </div>
      </section>

      {/* 4. SOLUTION */}
      <section className="bg-cream py-20 px-6" data-id="element-182">
        <div className="max-w-3xl mx-auto" data-id="element-183">
          <p className="section-eyebrow" data-id="element-184">La solución</p>
          <h2 className="text-dark mb-4" data-id="element-185">
            Por eso creamos el
            <br data-id="element-186" />
            <em className="text-gold-dark not-italic" data-id="element-187">
              KIT del Masajista Pro.
            </em>
          </h2>

          <div className="bg-white border-[1.5px] border-gold/20 rounded-[18px] p-8 md:p-10 relative overflow-hidden" data-id="element-188">
            <div className="absolute top-[-14px] left-[22px] font-playfair text-[130px] text-gold opacity-10 leading-none pointer-events-none" data-id="element-189">
              "
            </div>
            <p className="text-[18px] leading-[1.82] text-text relative z-10" data-id="element-190">
              No es un curso más de técnicas.
              <br data-id="element-191" />
              <br data-id="element-192" />
              <strong className="text-dark font-bold" data-id="element-193">
                Es un sistema completo que te guía paso a paso para dejar de
                improvisar y empezar a trabajar con seguridad, estructura y
                resultados reales.
              </strong>
              <br data-id="element-194" />
              <br data-id="element-195" />
              Basado en el{' '}
              <strong className="text-dark font-bold" data-id="element-196">
                Método M.A.S.A.J.E.™
              </strong>{' '}
              — desarrollado específicamente para masajistas que ya tienen el
              conocimiento pero necesitan el sistema que lo convierte en un
              trabajo rentable.
            </p>

            <div className="mt-7 bg-gradient-to-br from-dark to-dark-2 rounded-xl p-6 md:p-8 text-center" data-id="element-197">
              <p className="text-gold-light text-[19px] font-semibold font-playfair italic" data-id="element-198">
                "Aprendé a trabajar con clientes reales.
                <br data-id="element-199" />
                Generá ingresos reales como masajista."
              </p>
            </div>
          </div>

          <div className="mt-10" data-id="element-200"></div>
        </div>
      </section>

      {/* 5. METHOD M.A.S.A.J.E. */}
      <section className="bg-dark py-20 px-6" data-id="element-201">
        <div className="max-w-4xl mx-auto" data-id="element-202">
          <p className="section-eyebrow text-gold/75 text-center w-full block" data-id="element-203">
            El corazón del sistema
          </p>

          <div className="bg-gradient-to-br from-gold/10 to-gold/5 border-2 border-gold rounded-2xl p-8 md:p-9 text-center mb-10" data-id="element-204">
            <p className="font-playfair text-[clamp(28px,4vw,44px)] font-black text-gold-light leading-[1.1] mb-3" data-id="element-205">
              Método M.A.S.A.J.E.™
            </p>
            <p className="text-white/65 text-[16px] max-w-[520px] mx-auto leading-relaxed" data-id="element-206">
              El sistema que transforma tu forma de trabajar — de masajista que
              improvisa a profesional que cobra con confianza y llena su agenda.
            </p>
          </div>

          <div className="mb-10" data-id="element-207">
            <img src="https://cdn.magicpatterns.com/uploads/oMgJWYkaFn3vMyj88q2YYk/Mockup_producto_final.jpg" alt="Kit del Masajista Pro - Método M.A.S.A.J.E.™ producto completo" className="w-full rounded-xl shadow-2xl mx-auto" style={{
            objectFit: 'contain',
            maxHeight: '520px'
          }} data-mp-image="method-image" data-id="element-208" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4.5 mt-10" data-id="element-209">
            {[{
            l: 'M',
            t: 'Mentalidad',
            d: 'Aprendé a cobrar lo que vale tu trabajo y a valorarte como profesional. Sin culpa, sin descuentos innecesarios, con convicción.'
          }, {
            l: 'A',
            t: 'Anatomía',
            d: 'Entendé el cuerpo para trabajar con seguridad y precisión. Cada maniobra con propósito. Sin miedo de lastimar, con confianza en cada toque.'
          }, {
            l: 'S',
            t: 'Sesiones',
            d: 'Estructurá cada atención de principio a fin. Un protocolo claro que te saca la improvisación y le da al cliente una experiencia que quiere repetir.'
          }, {
            l: 'A',
            t: 'Atención',
            d: 'Generá una experiencia profesional real. Sabés qué decir, cómo recibirlos y cómo cerrar cada sesión para que el cliente vuelva solo.'
          }, {
            l: 'J',
            t: 'Jornadas',
            d: 'Organizá tu agenda y tus ingresos. Dejás de depender de que "aparezca" alguien y empezás a construir una semana de trabajo predecible y rentable.'
          }, {
            l: 'E',
            t: 'Expansión',
            d: 'Convertí todo esto en un negocio que crece. Más servicios, más packs, más clientes recurrentes. Vivir de los masajes deja de ser un sueño.'
          }].map((pilar, i) => <div key={i} className="bg-white/5 border border-gold/25 rounded-xl p-6 relative overflow-hidden" data-id="element-210">
                <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-gold to-accent" data-id="element-211"></div>
                <div className="font-playfair text-[52px] font-black text-gold/10 leading-none mb-1.5" data-id="element-212">
                  {pilar.l}
                </div>
                <div className="text-[17px] font-bold text-gold-light mb-2.5" data-id="element-213">
                  {pilar.t}
                </div>
                <p className="text-[14px] text-white/60 leading-relaxed" data-id="element-214">
                  {pilar.d}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. WHAT'S INCLUDED */}
      <section className="bg-white py-20 px-6" data-id="element-215">
        <div className="max-w-3xl mx-auto" data-id="element-216">
          <p className="section-eyebrow" data-id="element-217">Todo incluido</p>
          <h2 className="text-dark mb-4" data-id="element-218">
            Todo lo que necesitás para
            <br data-id="element-219" />
            <em className="text-gold-dark not-italic" data-id="element-220">empezar hoy mismo.</em>
          </h2>
          <p className="text-[17px] text-muted leading-relaxed mb-7" data-id="element-221">
            Descarga digital. Acceso inmediato. Listo para aplicar en tu próximo
            turno.
          </p>

          <div className="mb-10" data-id="element-222">
            <img src="https://cdn.magicpatterns.com/uploads/3B9xAgorW31jtgB3L43uE5/Mockup_secundario_landing.jpg" alt="Kit completo de materiales profesionales" className="w-full rounded-xl shadow-2xl mx-auto" style={{
            objectFit: 'contain',
            maxHeight: '520px'
          }} data-mp-image="whats-included-image" data-id="element-223" />
          </div>

          <div className="flex flex-col gap-3.5 mt-10" data-id="element-224">
            {[{
            t: 'Protocolo Maestro de Sesión Completa',
            d: 'Paso a paso de inicio a fin — bienvenida, evaluación, ejecución y cierre. Nunca más improvisás. Cada sesión tiene estructura y propósito desde el primer minuto.',
            b: 'CENTRAL'
          }, {
            t: 'Guía de Técnicas y Ejecución Segura',
            d: 'Secuencias con la presión, ritmo y postura correcta. Trabajás sin miedo de lastimar y con resultados que el cliente siente — y que lo hacen volver.',
            b: null
          }, {
            t: 'Kit Completo de Fichas y Plantillas de Cliente',
            d: 'Fichas de evaluación, consentimientos y seguimiento listos para imprimir o usar digital. Solo completás tu nombre y arrancás. Tu gabinete va a verse como una clínica.',
            b: 'LISTO YA'
          }, {
            t: 'Manual de Comunicación y Experiencia del Cliente',
            d: 'Qué decir en cada momento: antes de la sesión, durante la evaluación, al terminar y al ofrecer el próximo turno. Comunicación que genera confianza y retención.',
            b: null
          }, {
            t: 'Sistema de Precios, Packs y Turnos Recurrentes',
            d: 'Cómo calcular tus tarifas, cómo armar packs irresistibles y el sistema exacto para que tus clientes vuelvan solos y te recomienden. Ingresos predecibles, mes a mes.',
            b: 'MÁS PEDIDO'
          }].map((item, i) => <div key={i} className="flex items-start gap-4 bg-white border border-gold/20 rounded-lg p-5 hover:border-gold/45 transition-colors" data-id="element-225">
                <div className="w-7 h-7 min-w-[28px] rounded-full bg-green-light flex items-center justify-center mt-0.5 text-[13px] text-green font-extrabold" data-id="element-226">
                  <Check size={16} strokeWidth={4} data-id="element-227" />
                </div>
                <div className="flex-1" data-id="element-228">
                  <strong className="block text-[16px] font-bold text-dark mb-1" data-id="element-229">
                    {item.t}
                  </strong>
                  <span className="text-[14px] text-muted leading-relaxed" data-id="element-230">
                    {item.d}
                  </span>
                </div>
                {item.b && <span className="hidden sm:inline-block ml-auto min-w-fit bg-green-light text-green text-[11px] font-bold px-2.5 py-1 rounded-full tracking-wide self-center whitespace-nowrap" data-id="element-231">
                    {item.b}
                  </span>}
              </div>)}
          </div>

          <div className="text-center mt-9 p-5 md:p-6 bg-green-light border-[1.5px] border-green/20 rounded-xl" data-id="element-232">
            <p className="text-[17px] font-bold text-green" data-id="element-233">
              👉 Vas a tener claridad, orden y seguridad desde el primer día.
            </p>
          </div>

          <div className="text-center mt-8" data-id="element-234">
            <a href="#precio" className="btn-gold text-[21px] px-14 py-6" data-id="element-235">
              Quiero Acceso Ahora →
            </a>
          </div>
        </div>
      </section>

      {/* 7. RESULTS */}
      <section className="bg-dark py-20 px-6" data-id="element-236">
        <div className="max-w-4xl mx-auto" data-id="element-237">
          <p className="section-eyebrow text-gold/75" data-id="element-238">El cambio real</p>
          <h2 className="text-white mb-4" data-id="element-239">
            ¿Qué vas a lograr
            <br data-id="element-240" />
            <em className="text-gold-dark not-italic" data-id="element-241">con este sistema?</em>
          </h2>
          <p className="text-[17px] text-white/60 leading-relaxed mb-7" data-id="element-242">
            Es empezar a generar ingresos reales con algo que te gusta. Es
            convertir tu talento en un trabajo que te da estabilidad, orgullo y
            libertad.
          </p>

          <div className="mb-8" data-id="element-243">
            <img src="https://cdn.magicpatterns.com/uploads/fDUGCwMRTmfogduK6aFJAT/img_6_landing.jpg" alt="Masajista satisfecha revisando su agenda" className="w-full max-w-md mx-auto rounded-xl shadow-2xl" style={{
            objectFit: 'cover',
            aspectRatio: '1/1'
          }} data-mp-image="results-image" data-id="element-244" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8" data-id="element-245">
            <div className="bg-white border border-gold/20 rounded-xl p-5 md:p-6" data-id="element-246">
              <div className="text-[26px] mb-2.5" data-id="element-247">
                <Users className="text-gold" size={28} data-id="element-248" />
              </div>
              <div className="text-[15px] font-bold text-dark mb-1.5" data-id="element-249">
                Más clientes que vuelven
              </div>
              <p className="text-[13px] text-muted leading-relaxed" data-id="element-250">
                Con el sistema de comunicación y fidelización, tus clientes
                dejan de ser "de una vez" y se convierten en recurrentes que te
                recomiendan.
              </p>
            </div>
            <div className="bg-white border border-gold/20 rounded-xl p-5 md:p-6" data-id="element-251">
              <div className="text-[26px] mb-2.5" data-id="element-252">
                <Dumbbell className="text-gold" size={28} data-id="element-253" />
              </div>
              <div className="text-[15px] font-bold text-dark mb-1.5" data-id="element-254">
                Más confianza en cada sesión
              </div>
              <p className="text-[13px] text-muted leading-relaxed" data-id="element-255">
                Llegás al gabinete sabiendo exactamente qué vas a hacer. La
                inseguridad desaparece. Tus manos trabajan con propósito.
              </p>
            </div>
            <div className="bg-white border border-gold/20 rounded-xl p-5 md:p-6" data-id="element-256">
              <div className="text-[26px] mb-2.5" data-id="element-257">
                <DollarSign className="text-gold" size={28} data-id="element-258" />
              </div>
              <div className="text-[15px] font-bold text-dark mb-1.5" data-id="element-259">
                Más ingresos por sesión
              </div>
              <p className="text-[13px] text-muted leading-relaxed" data-id="element-260">
                Con el sistema de precios y packs, cobrás lo que vale tu trabajo
                sin incomodidad. Fin de los descuentos por miedo.
              </p>
            </div>
            <div className="bg-white border border-gold/20 rounded-xl p-5 md:p-6" data-id="element-261">
              <div className="text-[26px] mb-2.5" data-id="element-262">
                <Star className="text-gold" size={28} data-id="element-263" />
              </div>
              <div className="text-[15px] font-bold text-dark mb-1.5" data-id="element-264">
                Más profesionalismo visible
              </div>
              <p className="text-[13px] text-muted leading-relaxed" data-id="element-265">
                Fichas, protocolos, comunicación. El cliente percibe la
                diferencia desde que entra al gabinete. Eso construye
                reputación.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4.5 mt-10" data-id="element-266">
            <div className="bg-red-light border-[1.5px] border-red/15 rounded-xl p-6 md:p-7" data-id="element-267">
              <h3 className="text-[13px] font-extrabold tracking-[1.5px] uppercase text-red mb-4.5" data-id="element-268">
                Sin el Kit
              </h3>
              <ul className="flex flex-col gap-2.5" data-id="element-269">
                {['Cada sesión es diferente y sin orden', 'No sabés cuánto cobrar', 'Los clientes no vuelven y no sabés por qué', 'Ingresos inestables mes a mes', 'Inseguridad que el cliente percibe'].map((item, i) => <li key={i} className="text-[14px] leading-relaxed pl-5 relative text-[#7A2020]" data-id="element-270">
                    <span className="absolute left-0 text-red font-bold" data-id="element-271">
                      →
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-green-light border-[1.5px] border-green/20 rounded-xl p-6 md:p-7" data-id="element-272">
              <h3 className="text-[13px] font-extrabold tracking-[1.5px] uppercase text-green mb-4.5" data-id="element-273">
                Con el Kit
              </h3>
              <ul className="flex flex-col gap-2.5" data-id="element-274">
                {['Protocolo claro de inicio a fin', 'Precios definidos con confianza', 'Clientes que vuelven y recomiendan', 'Agenda llena e ingresos predecibles', 'Seguridad que se transmite y fideliza'].map((item, i) => <li key={i} className="text-[14px] leading-relaxed pl-5 relative text-[#1A4A24]" data-id="element-275">
                    <span className="absolute left-0 text-green font-bold" data-id="element-276">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. TESTIMONIALS */}
      <section className="bg-cream py-20 px-6" data-id="element-277">
        <div className="max-w-4xl mx-auto" data-id="element-278">
          <p className="section-eyebrow" data-id="element-279">Resultados reales</p>
          <h2 className="text-dark mb-4" data-id="element-280">
            Masajistas que ya aplicaron
            <br data-id="element-281" />
            el sistema —{' '}
            <em className="text-gold-dark not-italic" data-id="element-282">en sus palabras.</em>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8" data-id="element-283">
            {[{
            t: '"Antes sentía que improvisaba en cada sesión y no sabía cuánto cobrar. Hoy tengo todo organizado, mis sesiones tienen estructura y mis clientes vuelven. Fue el cambio que necesitaba."',
            n: 'Laura M.',
            d: 'Masajista independiente · Córdoba',
            img: 'https://cdn.magicpatterns.com/uploads/4u8UstEQmskMdZfg5dJvn5/img_testimonio_1.jpg'
          }, {
            t: '"Pasé de no tener estabilidad a llenar mi agenda varios días a la semana. El sistema de packs cambió todo — ahora sé cómo ofrecer mis servicios sin sentirme pesada o desesperada."',
            n: 'Sofía C.',
            d: 'Terapeuta holística · Buenos Aires',
            img: 'https://cdn.magicpatterns.com/uploads/uFUa1D3UjwYJaGV2vi7khf/img_testimonio_2.jpg'
          }, {
            t: '"Ahora sé cuánto cobrar y gano mucho más con menos sesiones. Subí mis precios con el método del Kit y no perdí a ningún cliente. Al contrario — los que quedaron valoran mucho más el servicio."',
            n: 'Valeria R.',
            d: 'Gabinete propio · Rosario',
            img: 'https://cdn.magicpatterns.com/uploads/rg4VBfCiY9LTf9UPBwftfs/img_testimonio_3.jpg'
          }].map((test, i) => <div key={i} className="bg-white border border-gold/20 rounded-xl p-6 flex flex-col items-center text-center" data-id="element-284">
                <img src={test.img} alt={test.n} className="w-20 h-20 rounded-full object-cover mb-4 border-2 border-gold/30" data-mp-image={`testimonial-${i + 1}`} data-id="element-285" />
                <div className="text-gold text-[15px] tracking-[1px] mb-3 flex gap-0.5 justify-center" data-id="element-286">
                  <Star size={14} fill="currentColor" data-id="element-287" />
                  <Star size={14} fill="currentColor" data-id="element-288" />
                  <Star size={14} fill="currentColor" data-id="element-289" />
                  <Star size={14} fill="currentColor" data-id="element-290" />
                  <Star size={14} fill="currentColor" data-id="element-291" />
                </div>
                <p className="text-[14px] leading-[1.7] text-text mb-4 italic" data-id="element-292">
                  {test.t}
                </p>
                <div className="mt-auto" data-id="element-293">
                  <div className="text-[14px] font-bold text-dark" data-id="element-294">
                    {test.n}
                  </div>
                  <div className="text-[12px] text-muted" data-id="element-295">{test.d}</div>
                  <span className="text-[11px] text-green font-semibold mt-2 inline-flex items-center gap-0.5" data-id="element-296">
                    <Check size={12} strokeWidth={3} data-id="element-297" /> Verificado
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 9. BONUSES */}
      <section className="bg-gradient-to-b from-[#FFF8EB] to-[#FFF2D4] border-y-2 border-gold py-20 px-6" data-id="element-298">
        <div className="max-w-4xl mx-auto" data-id="element-299">
          <div className="text-center mb-9 mt-10" data-id="element-300">
            <p className="inline-block bg-gold text-dark text-[11px] font-extrabold tracking-[1.5px] uppercase px-5 py-2 rounded-full mb-3.5" data-id="element-301">
              🎁 Bonos incluidos
            </p>
            <h2 className="text-dark mb-4" data-id="element-302">
              Y además, te llevás
              <br data-id="element-303" />
              <em className="text-gold-dark not-italic" data-id="element-304">
                estos bonos de regalo.
              </em>
            </h2>
            <p className="text-[17px] text-muted leading-relaxed max-w-[520px] mx-auto" data-id="element-305">
              Herramientas extra para aumentar tu valor, diferenciarte y ganar
              más por sesión — desde el primer día.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6" data-id="element-306">
            {[{
            n: 'Bono 01',
            t: 'Protocolo Completo de Masaje Facial Premium',
            d: 'Un servicio diferencial que muy pocas masajistas ofrecen. Con este protocolo podés agregar una técnica de alto valor a tu menú y cobrar considerablemente más por sesión.'
          }, {
            n: 'Bono 02',
            t: 'Manual Completo de Maderoterapia Profesional',
            d: 'Una de las técnicas más buscadas y mejor pagas del mercado hoy. Con este manual podés empezar a ofrecerla de inmediato y diferenciarte de la competencia local.'
          }, {
            n: 'Bono 03',
            t: 'Pack de Plantillas Profesionales de Gabinete',
            d: 'Todo el material administrativo que necesitás: fichas de evaluación, consentimientos y seguimiento. Solo completás tu logo y listo — tu gabinete se ve de otra categoría.'
          }, {
            n: 'Bono 04',
            t: 'Sistema de Agenda Llena: Turnos Recurrentes',
            d: 'El método exacto para que tu agenda se llene semana a semana sin depender de recomendaciones. Sistema real, predecible y replicable todas las semanas.'
          }, {
            n: 'Bono 05',
            t: 'Acceso a la Comunidad Privada Método MASAJE™',
            d: 'Vas a formar parte de un espacio exclusivo donde otros masajistas están aplicando el método, resolviendo dudas y creciendo profesionalmente. Tendrás acompañamiento, apoyo y motivación constante.'
          }].map((bono, i) => <div key={i} className="bg-white border-[1.5px] border-gold/40 rounded-xl p-6 md:p-5" data-id="element-307">
                <p className="text-[10px] font-extrabold tracking-[2px] uppercase text-gold-dark mb-2" data-id="element-308">
                  {bono.n}
                </p>
                <p className="text-[16px] font-bold text-dark mb-2 leading-[1.3]" data-id="element-309">
                  {bono.t}
                </p>
                <p className="text-[13px] text-muted leading-[1.6]" data-id="element-310">{bono.d}</p>
                <p className="mt-3 text-[12px] font-bold text-green flex items-center gap-1" data-id="element-311">
                  <Check size={14} strokeWidth={3} data-id="element-312" /> Incluido sin costo extra
                </p>
              </div>)}
          </div>

          <div className="bg-gradient-to-br from-dark to-dark-2 rounded-xl p-6 md:p-7 flex flex-col sm:flex-row items-start sm:items-center gap-4.5" data-id="element-313">
            <div className="w-12 h-12 min-w-[48px] rounded-full bg-gold/15 border border-gold/30 flex items-center justify-center text-[20px] text-gold-light shrink-0" data-id="element-314">
              <MessageCircle size={24} data-id="element-315" />
            </div>
            <div data-id="element-316">
              <strong className="block text-gold-light text-[15px] font-bold mb-1" data-id="element-317">
                PLUS: Scripts de WhatsApp para Cerrar Turnos
              </strong>
              <span className="text-white/60 text-[13px] leading-[1.55]" data-id="element-318">
                Mensajes probados listos para copiar: para responder consultas,
                confirmar turnos y vender packs sin sentirte pesada. Solo
                copiás, personalizás y enviás.
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* 10. URGENCY */}
      <section className="bg-dark py-20 px-6 text-center" data-id="element-319">
        <div className="max-w-3xl mx-auto" data-id="element-320">
          <p className="section-eyebrow text-gold/75" data-id="element-321">Precio especial</p>
          <h2 className="text-white mb-4" data-id="element-322">
            Acceso inmediato
            <br data-id="element-323" />
            con{' '}
            <em className="text-gold-dark not-italic" data-id="element-324">
              precio de lanzamiento.
            </em>
          </h2>
          <p className="text-[17px] text-white/60 leading-relaxed max-w-[520px] mx-auto mb-8" data-id="element-325">
            Esta oferta puede cambiar en cualquier momento. El precio actual
            existe para que no haya excusas para empezar.
          </p>

          <div className="bg-gold/10 border border-gold/30 rounded-xl p-8 md:p-7 max-w-[480px] mx-auto mb-8" data-id="element-326">
            <p className="text-[12px] font-bold tracking-[2px] uppercase text-gold/70 mb-4" data-id="element-327">
              Lo que incluye hoy
            </p>
            <div className="flex flex-col gap-2.5 text-left mb-6" data-id="element-328">
              {['Sistema M.A.S.A.J.E.™ completo', 'Protocolo maestro de sesión', 'Kit de fichas y plantillas editables', 'Sistema de precios y packs', '5 bonos + scripts de WhatsApp', 'Garantía 7 días sin preguntas'].map((item, i) => <span key={i} className="text-white/75 text-[14px] flex items-center gap-2" data-id="element-329">
                  <Check className="text-gold" size={16} strokeWidth={3} data-id="element-330" />{' '}
                  {item}
                </span>)}
            </div>
            <a href="#precio" className="btn-gold block text-center text-[16px] px-8 py-4 w-full" data-id="element-331">
              👉 Aprovechá ahora →
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-5" data-id="element-332">
            <p className="text-white/50 text-[14px] flex items-center gap-1.5" data-id="element-333">
              <Check className="text-green" size={16} data-id="element-334" /> No necesitás
              experiencia previa
            </p>
            <p className="text-white/50 text-[14px] flex items-center gap-1.5" data-id="element-335">
              <Check className="text-green" size={16} data-id="element-336" /> Podés empezar desde hoy
            </p>
            <p className="text-white/50 text-[14px] flex items-center gap-1.5" data-id="element-337">
              <Check className="text-green" size={16} data-id="element-338" /> Todo explicado paso a
              paso
            </p>
          </div>
        </div>
      </section>

      {/* 11. FAQ */}
      <section className="bg-white py-20 px-6" data-id="element-339">
        <div className="max-w-3xl mx-auto" data-id="element-340">
          <p className="section-eyebrow" data-id="element-341">Preguntas frecuentes</p>
          <h2 className="text-dark mb-4" data-id="element-342">
            Todo lo que querés saber
            <br data-id="element-343" />
            antes de <em className="text-gold-dark not-italic" data-id="element-344">dar el paso.</em>
          </h2>

          <div className="flex flex-col gap-2.5 mt-8" data-id="element-345">
            {[{
            q: '📩 ¿Cómo recibo el Kit y cuándo tengo acceso?',
            a: 'Apenas completás el pago recibís automáticamente un correo con acceso a todo el Kit. En menos de 2 minutos podés abrir todo desde tu celular o computadora — sin esperar aprobaciones ni hablar con nadie.'
          }, {
            q: '💻 ¿En qué formato recibo el material?',
            a: 'Todo es 100% digital. Guías, protocolos y plantillas en PDF descargable y editable, organizados en Google Drive. Podés acceder desde cualquier dispositivo — incluso desde el gabinete entre turno y turno.'
          }, {
            q: '🛠️ ¿Sirve si ya trabajo como masajista?',
            a: 'Especialmente para vos. El Kit está diseñado para masajistas que ya trabajan pero sienten que les falta orden, seguridad o ingresos constantes. Si ya tenés clientes, vas a notar la diferencia desde la primera sesión en que apliques el protocolo.'
          }, {
            q: '💰 ¿Puedo recuperar la inversión rápido?',
            a: 'Con un solo pack de 3 sesiones vendido usando el sistema incluido en el Kit, ya recuperás la inversión completa. El precio de lanzamiento fue pensado exactamente para eso — para que el retorno sea inmediato.'
          }, {
            q: '⏳ ¿Por cuánto tiempo tengo acceso?',
            a: 'Para siempre. Pagás una sola vez, descargás el material y es tuyo. Sin suscripciones, sin renovaciones, sin costos ocultos. Podés revisarlo hoy, en seis meses o cuando lo necesites.'
          }, {
            q: '🛡️ ¿Y si no es lo que esperaba?',
            a: 'Tenés 7 días de garantía total. Si sentís que el Kit no te aporta claridad, protocolo o herramientas aplicables, escribís y te devolvemos el 100% del dinero. Sin preguntas, sin condiciones, sin demoras. El riesgo es completamente nuestro.'
          }].map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} isOpen={openFaq === i} onClick={() => toggleFaq(i)} data-id="element-346" />)}
          </div>
        </div>
      </section>

      {/* 12. GUARANTEE */}
      <section className="bg-dark py-20 px-6" data-id="element-347">
        <div className="max-w-3xl mx-auto" data-id="element-348">
          <p className="section-eyebrow text-gold/75 text-center w-full block" data-id="element-349">
            Sin riesgos
          </p>
          <h2 className="text-white text-center mb-8" data-id="element-350">
            Garantía total de{' '}
            <em className="text-gold-dark not-italic" data-id="element-351">7 días.</em>
            <br data-id="element-352" />
            El riesgo es nuestro.
          </h2>

          <div className="bg-gradient-to-br from-dark to-dark-2 border-2 border-gold/35 rounded-2xl p-8 md:p-10 flex flex-col md:flex-row items-center md:items-start gap-8 text-center md:text-left" data-id="element-353">
            <div className="w-20 h-20 rounded-full bg-gold/10 border-2 border-gold/30 flex items-center justify-center text-[36px] shrink-0 mx-auto md:mx-0 text-gold-light" data-id="element-354">
              <Shield size={40} data-id="element-355" />
            </div>
            <div data-id="element-356">
              <h3 className="text-gold-light text-[22px] mb-2.5" data-id="element-357">
                Garantía de Satisfacción de 7 Días
              </h3>
              <p className="text-white/65 text-[15px] leading-[1.75]" data-id="element-358">
                Con el Kit del Masajista Pro tenés{' '}
                <strong className="text-gold-light font-bold" data-id="element-359">
                  7 días de prueba real en tu gabinete
                </strong>
                .<br data-id="element-360" />
                <br data-id="element-361" />
                Si en ese tiempo sentís que el sistema no te da protocolos
                claros, herramientas reales ni mejoras concretas en tu trabajo —
                <strong className="text-gold-light font-bold" data-id="element-362">
                  {' '}
                  te devolvemos el 100% de tu dinero. Sin excusas, sin
                  condiciones, sin preguntas.
                </strong>
                <br data-id="element-363" />
                <br data-id="element-364" />
                El riesgo es completamente nuestro.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 13. PRICING */}
      <section id="precio" className="bg-dark py-20 px-6" data-id="element-365">
        <div className="max-w-4xl mx-auto" data-id="element-366">
          <p className="section-eyebrow text-gold/75 text-center w-full block" data-id="element-367">
            Tu inversión hoy
          </p>

          <div className="bg-gradient-to-br from-gold/10 to-gold/5 border-2 border-gold rounded-[20px] p-10 md:p-12 text-center relative overflow-hidden" data-id="element-368">
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_60%_50%_at_50%_0%,rgba(200,155,60,0.08)_0%,transparent_70%)] pointer-events-none" data-id="element-369"></div>

            <div className="inline-block bg-[#E8A830]/20 border border-[#E8A830]/40 text-gold text-[11px] font-extrabold tracking-[2px] uppercase px-4 py-1.5 rounded-full mb-4 relative z-10" data-id="element-370">
              🔥 Precio de lanzamiento
            </div>

            <h2 className="text-white mb-2 relative z-10" data-id="element-371">
              Todo el sistema.
              <br data-id="element-372" />
              <em className="text-gold-dark not-italic" data-id="element-373">
                Un solo pago. Acceso inmediato.
              </em>
            </h2>
            <p className="text-[17px] text-white/60 leading-relaxed max-w-[480px] mx-auto mb-7 relative z-10" data-id="element-374">
              Sin cuotas ocultas. Sin sorpresas. Sin suscripciones. Todo
              incluido.
            </p>

            <div className="flex items-center justify-center gap-5 flex-wrap mb-3 relative z-10" data-id="element-375">
              <span className="text-[20px] text-white/30 line-through font-medium" data-id="element-376">
                $44.997 ARS
              </span>
              <span className="font-playfair text-[64px] font-black text-gold-light leading-none" data-id="element-377">
                $18.999
              </span>
              <span className="bg-[#E8A830] text-dark text-[13px] font-extrabold px-3.5 py-1.5 rounded-md" data-id="element-378">
                -57% OFF
              </span>
            </div>

            <p className="text-[13px] text-white/40 mb-7 relative z-10" data-id="element-379">
              ARS · Pago único · Acceso inmediato · Para siempre
            </p>

            <div className="flex flex-wrap justify-center gap-2.5 my-5 mb-7 relative z-10" data-id="element-380">
              {['Sistema M.A.S.A.J.E.™', 'Protocolo maestro', 'Fichas y plantillas', 'Sistema de precios', '5 bonos', 'Scripts WhatsApp', 'Garantía 7 días'].map((item, i) => <span key={i} className="bg-white/5 border border-white/10 text-white/65 text-[12px] px-3.5 py-1 rounded-full flex items-center gap-1" data-id="element-381">
                  <Check className="text-green" size={12} strokeWidth={4} data-id="element-382" />{' '}
                  {item}
                </span>)}
            </div>

            <a href="#precio" className="btn-gold block max-w-[460px] mx-auto text-[20px] px-12 py-6 relative z-10" data-id="element-383">
              👉 QUIERO EMPEZAR HOY
            </a>

            <div className="mt-4.5 flex justify-center gap-5 flex-wrap relative z-10" data-id="element-384">
              <span className="text-white/40 text-[12px] flex items-center gap-1" data-id="element-385">
                <Check className="text-green" size={14} data-id="element-386" /> Pago 100% seguro
              </span>
              <span className="text-white/40 text-[12px] flex items-center gap-1" data-id="element-387">
                <Check className="text-green" size={14} data-id="element-388" /> Acceso inmediato
              </span>
              <span className="text-white/40 text-[12px] flex items-center gap-1" data-id="element-389">
                <Check className="text-green" size={14} data-id="element-390" /> Sin suscripción
              </span>
              <span className="text-white/40 text-[12px] flex items-center gap-1" data-id="element-391">
                <Check className="text-green" size={14} data-id="element-392" /> Garantía 7 días
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* 14. FINAL CLOSE */}
      <section className="bg-gradient-to-br from-dark-2 to-dark relative overflow-hidden py-20 px-6" data-id="element-393">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_55%_50%_at_50%_50%,rgba(200,155,60,0.07)_0%,transparent_70%)] pointer-events-none" data-id="element-394"></div>

        <div className="relative z-10 max-w-3xl mx-auto text-center" data-id="element-395">
          <p className="section-eyebrow text-gold/75" data-id="element-396">Es tu momento</p>
          <h2 className="text-white mb-4" data-id="element-397">
            Es momento de dejar de improvisar
            <br data-id="element-398" />y empezar a trabajar como
            <br data-id="element-399" />
            <em className="text-gold-dark not-italic" data-id="element-400">
              una verdadera profesional.
            </em>
          </h2>

          <p className="text-white/60 text-[17px] mb-8 leading-[1.75]" data-id="element-401">
            Podés seguir llegando a cada sesión sin saber exactamente qué hacer,
            dudando cuánto cobrar, viendo cómo los clientes no vuelven y los
            ingresos no aparecen.
            <br data-id="element-402" />
            <br data-id="element-403" />O podés dar el paso hoy. Con el Kit del Masajista Pro y el
            Método M.A.S.A.J.E.™ vas a tener el sistema completo para{' '}
            <strong className="text-gold-light font-bold" data-id="element-404">
              trabajar con confianza, cobrar bien y generar ingresos reales.
            </strong>
          </p>

          <div className="bg-gold/10 border border-gold/25 rounded-lg p-3.5 px-5 mb-7 text-gold-light text-[14px] font-medium max-w-xl mx-auto" data-id="element-405">
            ⚡ El precio de $18.999 es de lanzamiento. Cuando suba, sube para
            siempre y sin aviso previo.
          </div>

          <a href="#precio" className="btn-gold block max-w-[460px] mx-auto text-[20px] px-12 py-6" data-id="element-406">
            👉 QUIERO EMPEZAR HOY
          </a>

          <p className="text-white/35 text-[13px] mt-4" data-id="element-407">
            Acceso inmediato · Garantía 7 días · Un solo pago · Para siempre
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-dark border-t border-white/5 text-center py-7 px-6 text-white/30 text-[12px] font-dmsans" data-id="element-408">
        <p data-id="element-409">
          © 2025 Kit del Masajista Pro · Método M.A.S.A.J.E.™ · Todos los
          derechos reservados
        </p>
        <p className="mt-2" data-id="element-410">
          <a href="#" className="text-white/40 underline hover:text-white/60 transition-colors" data-id="element-411">
            Política de privacidad
          </a>{' '}
          ·{' '}
          <a href="#" className="text-white/40 underline hover:text-white/60 transition-colors" data-id="element-412">
            Términos y condiciones
          </a>
        </p>
      </footer>

      <StickyBar data-id="element-413" />
    </div>;
}